/**
 * @description 與要保人關係用
*/
export enum InsuredRelation {
  /** 本人 */
  Self = '1',
  /** 配偶 */
  Spouse = '2',
  /** 子女 */
  Child = '3',
  /** 祖父母 */
  Grand = '4',
  /** 兄弟姐妹 */
  Sibling = '5',
  /** 父母 */
  Parent = '6',
  /** 同被保人 */
  SameInsured = '7',
  /** 其他 */
  Other = '99'
}
